/** Shared in-memory cache for Guardians alert notification user preference. */

let alertNotificationsEnabled = false;
const listeners = new Set<() => void>();

export function getGuardiansAlertNotificationsEnabled(): boolean {
  return alertNotificationsEnabled;
}

export function setGuardiansAlertNotificationsEnabled(enabled: boolean): void {
  alertNotificationsEnabled = enabled;
  listeners.forEach((listener) => listener());
}

export function subscribeGuardiansAlertNotificationsPref(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
